/**
 * ErrorBoundary — catches React render errors, reports to Sentry, shows fallback UI
 */
import { Component } from 'react';
import { createLogger } from '../../utils/logger';

const log = createLogger('ErrorBoundary');

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    log.error('React render error', {
      error: error.message,
      componentStack: errorInfo.componentStack,
    });

    // Report to Sentry if available
    if (window.__SENTRY_INITIALIZED__) {
      import('../../utils/sentry').then(({ Sentry }) => {
        Sentry.captureException(error, { extra: errorInfo });
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="error-boundary" role="alert">
            <h2>Something went wrong</h2>
            <p>We're sorry for the inconvenience. Please try refreshing the page.</p>
            <button
              className="button button--primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
